import {
  claimTurnstileContainer,
  releaseTurnstileContainer,
} from '@/services/turnstile'
import { ref } from 'vue'

export function useTurnstileSlot() {
  const turnstileSlot = ref<HTMLElement | null>(null)

  async function withTurnstileSlot<T>(action: () => Promise<T>): Promise<T> {
    const container = turnstileSlot.value

    if (container) {
      claimTurnstileContainer(container)
    }

    try {
      return await action()
    } finally {
      if (container) {
        releaseTurnstileContainer(container)
      }
    }
  }

  return { turnstileSlot, withTurnstileSlot }
}
